'use client';

import { forwardRef, useImperativeHandle } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { CredentialsFields } from '@/shared/ui/forms/credentials-fields';
import {
    signupCredentialsSchema, type SignupCredentialsFormData,
} from '@/shared/lib/validation/registration-wizard/credentials';
import type { FormHandle } from '@/shared/ui/forms/form-handle';


type Props = {
    defaultValues?: Partial<SignupCredentialsFormData>;
    onSubmit      : (data: SignupCredentialsFormData) => void;
};


export const CredentialsSubForm = forwardRef<FormHandle<SignupCredentialsFormData>, Props>(function CredentialsSubForm ({ defaultValues, onSubmit }, ref) {
    const form = useForm<SignupCredentialsFormData>({
        resolver      : zodResolver(signupCredentialsSchema),
        mode          : 'onBlur',
        reValidateMode: 'onChange',
        defaultValues : {
            email   : '',
            password: '',
            terms   : false,
            ...defaultValues,
        },
    });

    useImperativeHandle(ref, () => ({
        submit: async () => {
            const valid = await form.trigger();
            if (!valid) return null;
            const values = form.getValues();
            onSubmit(values);
            return values;
        },
    }));

    return (
        <FormProvider { ...form }>
            <CredentialsFields/>
        </FormProvider>
    );
});
